import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { UiV2Scope } from '@kawai/ui';
import { SaasAdminGuard } from './components/SaasAdminGuard.js';
import { TenantsListPage } from './pages/TenantsListPage.js';
import { TenantCreatePage } from './pages/TenantCreatePage.js';
import { BillingPage } from './pages/BillingPage.js';
import { BankTransferBillingPage } from './pages/BankTransferBillingPage.js';
import { BillingDetailPage } from './pages/BillingDetailPage.js';
import { InvoicePrintPage } from './pages/InvoicePrintPage.js';
import { AuditLogsPage } from './pages/AuditLogsPage.js';
import { ExportPage } from './pages/ExportPage.js';
import { SignInPage } from './pages/SignInPage.js';
import { NotFoundPage } from './pages/NotFoundPage.js';

/**
 * saas-admin app の root route。
 *
 * - `/`              : SaasAdminGuard 配下の TenantsListPage（S-05）
 * - `/tenants/new`   : SaasAdminGuard 配下の TenantCreatePage（S-06）
 * - `/billing`       : SaasAdminGuard 配下の BillingPage（TP-22 月額サブスク開始）
 * - `/billing/bank-transfer` : BankTransferBillingPage（TP-27/TP-34 振込・口座振替請求管理 / 静的セグメントが :tenantId より優先）
 * - `/billing/:tenantId` : SaasAdminGuard 配下の BillingDetailPage（TP-25 決済明細 / 閲覧）
 * - `/billing/:tenantId/invoice/:chargeId` : InvoicePrintPage（TP-26 適格請求書 / 領収書）
 * - `/audit-logs`    : SaasAdminGuard 配下の AuditLogsPage（S-08）
 * - `/export`        : SaasAdminGuard 配下の ExportPage（S-57）
 * - `/signin`        : SignInPage
 * - `*`              : NotFoundPage
 *
 * S-137: 認証後のページ本体は `V2Scope`（`UiV2Scope`）で包み、書体・字間・行間（`.ui-v2`）と
 * @kawai/ui の v2 既定を当てる。**InvoicePrintPage は包まない**（適格請求書の印刷結果を変えない /
 * tenant-fuel の印刷 2 ページと同じ方針）。SignInPage は SignInCard の variant="v2" で対応。
 */
function V2Scope() {
  return (
    <UiV2Scope>
      <Outlet />
    </UiV2Scope>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/signin" element={<SignInPage />} />
        <Route
          path="/billing/:tenantId/invoice/:chargeId"
          element={
            <SaasAdminGuard>
              <InvoicePrintPage />
            </SaasAdminGuard>
          }
        />
        <Route element={<V2Scope />}>
          <Route
            path="/"
            element={
              <SaasAdminGuard>
                <TenantsListPage />
              </SaasAdminGuard>
            }
          />
          <Route
            path="/tenants/new"
            element={
              <SaasAdminGuard>
                <TenantCreatePage />
              </SaasAdminGuard>
            }
          />
          <Route
            path="/billing"
            element={
              <SaasAdminGuard>
                <BillingPage />
              </SaasAdminGuard>
            }
          />
          <Route
            path="/billing/bank-transfer"
            element={
              <SaasAdminGuard>
                <BankTransferBillingPage />
              </SaasAdminGuard>
            }
          />
          <Route
            path="/billing/:tenantId"
            element={
              <SaasAdminGuard>
                <BillingDetailPage />
              </SaasAdminGuard>
            }
          />
          <Route
            path="/audit-logs"
            element={
              <SaasAdminGuard>
                <AuditLogsPage />
              </SaasAdminGuard>
            }
          />
          <Route
            path="/export"
            element={
              <SaasAdminGuard>
                <ExportPage />
              </SaasAdminGuard>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
